import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

const API = '/api/v1/kasir/engagement/ads';

function createKasirAds() {
  return {
    loading: true,
    placements: [],
    networks: {},

    async init() {
      try {
        const { data } = await axios.get(API);
        this.placements = data.data?.placements || [];
        this.networks = data.data?.networks || {};
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat ads.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async save(p) {
      try {
        await axios.put(`${API}/${p.id}`, {
          enabled: p.enabled,
          network: p.network,
          unit_id: p.unit_id,
        });
        window.toast?.('Placement disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan.', 'error');
      }
    },
  };
}

Alpine.data('kasirAds', createKasirAds);
